/*
 * Copyright (c) 2025 Sila Artificial Intelligence Research LLC
 * A DA Holding Ltd Company
 * All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 * This software and its documentation are proprietary to Sila Artificial
 * Intelligence Research LLC. Unauthorized copying, distribution, or use
 * of this software is strictly prohibited.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const ErrorPage = () => {
  return <div className="p-4">Error</div>;
};

export default ErrorPage;
